export default "__VITE_ASSET__9Xacm1u1__"